import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { useMemo } from 'react';
import { Currency } from '@mews-commander/data-access';
import { useGlobalizationResultQuery } from './useGlobalizationResultQuery';

type CurrencyWithNonEmptyCode = Omit<Currency, 'code'> & { code: NonNullable<Currency['code']> };
const hasNonEmptyCurrencyCode = (currency: Currency): currency is CurrencyWithNonEmptyCode => !!currency.code;

export const useAllCurrencies = () => {
    const { data } = useGlobalizationResultQuery();
    const currencies = data?.currencies;

    return useMemo(() => {
        if (!currencies || array.isEmpty(currencies)) {
            return [];
        }

        return pipe(currencies, array.filter(hasNonEmptyCurrencyCode));
    }, [currencies]);
};
